export default {
	key: "market",
	basePath: "/market",
	exclude: true,
};
